import { IEmailImageBlock } from 'common/builder/blocks/blockInterfaces'
import {
  ConverterRule,
  EmailContentRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { EmailContentAttachmentSizeConverter } from 'common/builder/components/chart/FlowChart/lib/utils/EmailContentAttachmentSizeConverter'
import { getButtonsFromMap } from 'common/builder/components/chart/FlowChart/lib/utils/getButtonsFromMap'
import { PreviewConverter } from 'common/builder/components/chart/FlowChart/lib/utils/PreviewConverter'
import {
  EmailContentPreview,
  EmailContentType,
} from 'common/builder/components/chart/FlowChart/types/FlowChartEmailContent'
import { BlockType } from 'common/builder/constants/BlockType'
import { IUploadedImage } from 'common/builder/entityInterfaces'

export const EmailPreviewContentConverterRule: ConverterRule<
  IEmailImageBlock,
  EmailContentPreview,
  EmailContentRulePayload
> = {
  predicate: (entity: IEmailImageBlock) => entity?.type === BlockType.EMAIL_IMAGE,
  convert: (entity: IEmailImageBlock, { flowChartButtons }) => {
    const preview = PreviewConverter.fromIBlockImage(entity.image as IUploadedImage)

    if (!preview) {
      return null
    }

    return {
      id: entity.id,
      type: EmailContentType.PREVIEW,
      data: {
        preview,
        size: EmailContentAttachmentSizeConverter.getFromEmailImageSizePreset(
          entity.settings?.image_size?.value,
        ),
        buttons: getButtonsFromMap(entity.buttons, flowChartButtons),
      },
    }
  },
}
